import { Dialog, IconButton, styled } from '@mui/material';

export const XviaHomeSearch = styled('div')<{ isMediumScreen?: boolean }>(
  ({ isMediumScreen = false }) => ({
    height: isMediumScreen ? '100px' : '282px',
    width: '100%',
    backgroundColor: isMediumScreen
      ? 'var(--color-background-primary)'
      : 'var(--color-surface)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',

    '& img': {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      opacity: 0,
      transition: 'opacity 0.8s ease-in-out',
      zIndex: 1,
      display: 'var(--home-carousel-image-display)',
    },

    '& img.show': {
      opacity: 1,
    },
  })
);

export const HomeWrap = styled('div')<{ isMediumScreen?: boolean }>(
  ({ theme, isMediumScreen = false }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    alignItems: 'center',
    width: isMediumScreen ? 'calc(100% - 16px)' : '65%',
    margin: 'auto auto',
    transition: 'width 0.8s ease-in-out',
    color: '#000',

    '& .label': {
      width: '100%',
      textAlign: 'center',
      fontSize: 'var(--font-title-h1)',
      fontWeight: '700',
      lineHeight: 'var(--line-height-title-h1)',
      color: 'var(--xvia-color-title-contrast)',
      fontFamily: 'var(--xvia-font-family)',
      transition: 'all 0.8s ease-in-out',
      textShadow: '2px 2px 0px #000000',
      [theme.breakpoints.down(880)]: {
        fontSize: '28px',
      },
      [theme.breakpoints.down(560)]: {
        fontSize: '24px',
      },
    },
  })
);

export const HomeSearchWrap = styled('div')<{ isMediumScreen?: boolean }>(
  ({ isMediumScreen = false }) => ({
    display: 'flex',
    gap: isMediumScreen ? '0rem' : '2rem',
    width: '100%',
  })
);

export const HomeSearchInputWrap = styled('div')<{ isMediumScreen?: boolean }>(
  ({ isMediumScreen = false }) => ({
    display: 'flex',
    alignContent: 'center',
    flex: 1,
    height: '52px',
    gap: '8px',
    padding: '14px 24px',
    borderRadius: isMediumScreen ? '8px 0px 0px 8px' : '8px',
    backgroundColor: 'var(--color-input-background)',
    border: 'var(--color-input-border)',
    fontFamily: 'var(--xvia-font-family)',
    cursor: 'text',
    lineHeight: 'var(--line-height-body-1)',

    '& svg': {
      color: 'var(--color-grey-90)',
    },
  })
);

export const HomeSearchSuggestionsBoxWrapper = styled('section')(() => ({
  marginTop: '8px',
}));

export const HomeSearchSuggestionsBox = styled(HomeSearchInputWrap)(
  () => ({
    height: 'unset',
    borderRadius: '15px',
    gap: 'unset',
  })
);

export const HomeSearchSuggestionsBoxList = styled('ul')(() => ({
  width: '100%',
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export const HomeSearchSuggestionsBoxListItemWrapper = styled('li')(() => ({
  width: '100%',
  padding: '0px',
  margin: '0px',
  '&:hover': {
    color: 'var(--color-primary)',
  },
  transition: 'all 0.3s ease-in-out',
}));

export const HomeSearchSuggestionsBoxListItem = styled('div')(() => ({
  width: '100%',
  cursor: 'pointer',
  padding: '12px 8px',
}));

export const HomeSearchButton = styled('div')<{ isMediumScreen?: boolean }>({
  width: '52px',
  height: '52px',
  background: 'var(--color-button-primary)',
  borderRadius: '0px 8px 8px 0px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  color: 'white',
});

export const HomeSearchInputLabel = styled('label')(() => ({
  fontSize: 'var(--font-body-1)',
  color: 'var(--color-grey-80)',
  fontWeight: 'normal',
  cursor: 'text',
}));

export const HeaderActionsDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(8px)',
  },
  '& .MuiPaper-root': {
    width: '100%',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    position: 'absolute',
    top: 150,
    left: '45%',
    transform: 'translateX(-50%)',
    marginTop: 0,
    [theme.breakpoints.down(500)]: {
      left: '43%',
    },
    [theme.breakpoints.down(380)]: {
      left: '40%',
    },
  },
}));

export const HeaderActionsIconButton = styled(IconButton)(() => ({
  '&.search': {
    color: '#28272C',
    transition: 'color 0.5s ease-in-out',

    '&:hover': {
      color: '#0049A9',
    },
  },

  '&.menu': {
    color: '#0049A9',
  },

  '&.dialog': {
    position: 'absolute',
    right: 40,
    top: -10,
    color: '#FDFDFD',
  },
}));
